<!-- <section class="onboardingSecc">
    <div class="blurLayer"></div>
    <div class="onBoardingContainer">
        <div class="imgHeader" [ngClass]="{'normal': index > 0}" [style]="'background-image: url(../../../assets/' + onboardingCardArray[index].img + ');'"></div>
        <div class="bodyContainer">
            <h2>{{onboardingCardArray[index].title}}</h2>
            <p>{{onboardingCardArray[index].descripcion}}</p>
            <div class="buttonContainer">
                <app-medclass-button *ngIf="index == 0" [fixedWidth]="true" type="grey" label="Omitir" size="s" (click)="finalizarOnBoarding()"></app-medclass-button>
                <app-medclass-button *ngIf="index + 1 !== onboardingCardArray.length" [fixedWidth]="true" class="ms-3" type="white" [label]="index > 0 ? 'Siguiente' : 'Comenzar'" size="s" (click)="avanzarOnboarding()"></app-medclass-button>
                <app-medclass-button *ngIf="index + 1 == onboardingCardArray.length" [fixedWidth]="true" type="white" label="Entendido" size="s" (click)="finalizarOnBoarding()"></app-medclass-button>
            </div>
        </div>
    </div>
</section> -->

<div class="onBoardingContainer">
    <div class="imgHeader" [ngClass]="{'normal': index > 0}" [style]="'background-image: url(../../../assets/' + onboardingCardArray[index].img + ');'"></div>
    <div class="bodyContainer">
        <h2>{{onboardingCardArray[index].title}}</h2>
        <p>{{onboardingCardArray[index].descripcion}}</p>
        <div class="buttonContainer">
            <app-medclass-button *ngIf="index == 0" [fixedWidth]="true" type="grey" label="Omitir" size="s" (click)="finalizarOnBoarding()"></app-medclass-button>
            <app-medclass-button *ngIf="index + 1 !== onboardingCardArray.length" [fixedWidth]="true" class="ms-3" type="white" [label]="index > 0 ? 'Siguiente' : 'Comenzar'" size="s" (click)="avanzarOnboarding()"></app-medclass-button>
            <app-medclass-button *ngIf="index + 1 == onboardingCardArray.length" [fixedWidth]="true" type="white" label="Entendido" size="s" (click)="finalizarOnBoarding()"></app-medclass-button>
        </div>
    </div>
</div>